import { ColumnDetails, ColumnType } from '../../../../../../../../grid/types/common';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { html, TemplateResult } from 'lit';
import { getExchangeAntimalwareScanTaskTargetTypeGridOptions } from '../../../../../utils/uiSettings/exchange/exchange-protection.values';
import { ExchangeAntimalwareScanTask, RecurrenceType } from '@nirvana/shared/dtos/types/policies/common';
import {
  getRepeatIntervalFormOptions,
  getWeekDaysFormOptions,
  WeekDaysValues,
  WeekDayValueToScheduleFieldNameExchange,
} from '../../../../../../../common/policyPanel/uiSettings/schedulerTemplate/types';
import { GridFilterUiConfiguration } from '../../../../../../../../types/filters/types';

export enum Column {
  NAME = 1,
  TARGET_TYPE = 2,
  RECURRENCE = 3,
}

export enum ColumnKeys {
  NAME = 'name',
  TARGET_TYPE = 'targetType',
  RECURRENCE = 'scheduler',
}

export const GRID_COLUMNS = [Column.NAME, Column.TARGET_TYPE, Column.RECURRENCE];

export const FILTERS = [{ [ColumnKeys.NAME]: { contains: '' } }, { [ColumnKeys.TARGET_TYPE]: { in: [] } }];
export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.NAME, ColumnKeys.TARGET_TYPE];
export const FILTERS_UI_CONFIGS: Array<GridFilterUiConfiguration> = [
  {
    key: ColumnKeys.TARGET_TYPE,
    config: {
      allowSelectNone: true,
    },
  },
];

export function getGridColumnDetails(): Array<ColumnDetails<Column, ColumnKeys>> {
  return [
    {
      column: Column.NAME,
      key: ColumnKeys.NAME,
      columnName: translateFn('Task name'),
      type: ColumnType.STRING,
      removable: false,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.TARGET_TYPE,
      key: ColumnKeys.TARGET_TYPE,
      columnName: translateFn('Target'),
      values: getExchangeAntimalwareScanTaskTargetTypeGridOptions(),
      type: ColumnType.ENUM,
      removable: false,
      sortable: true,
      editingDisabled: true,
    },
    {
      column: Column.RECURRENCE,
      key: ColumnKeys.RECURRENCE,
      columnName: translateFn('Recurrence'),
      type: ColumnType.STRING,
      removable: false,
      sortable: false,
      editingDisabled: true,
      filteringDisabled: true,
    },
  ];
}

export function nameCellCustomRenderer(
  dispatchClickEventFn: (item) => void,
  rowData: unknown & { item: ExchangeAntimalwareScanTask }
): TemplateResult {
  return html` <span
    class="accent cell-label"
    style="cursor: pointer"
    @click="${() => dispatchClickEventFn(rowData.item)}"
    >${rowData.item.name}</span
  >`;
}

export function recurrenceCellCustomRenderer(rowData: unknown & { item: ExchangeAntimalwareScanTask }): TemplateResult {
  let cellText = '';

  switch (rowData.item.scheduler.recurrenceType) {
    case RecurrenceType.SCHEDULE:
      cellText =
        cellText +
        translateFn('Every') +
        ' ' +
        rowData.item.scheduler.recurrenceStep +
        ' ' +
        getRepeatIntervalFormOptions()[rowData.item.scheduler.recurrenceStepType].title;
      break;

    case RecurrenceType.WEEKDAYS:
      const weekDays = WeekDaysValues.filter(x => rowData.item.scheduler[WeekDayValueToScheduleFieldNameExchange[x]]);
      const weekDaysFormOptions = getWeekDaysFormOptions();

      // get the labels for the selected week days
      const days: string[] = [];
      weekDaysFormOptions.forEach(option => {
        if (weekDays.includes(option.value)) {
          days.push(option.label);
        }
      });

      cellText = cellText + translateFn('Every') + ' ' + days.join(', ');
      break;
  }

  return html`<span class="cell-label">${cellText}</span>`;
}
